import { useTranslation } from 'react-i18next'

import { Button, Dialog } from '@/components/UI'

type Props = {
  opened: boolean
  onClose: () => void
  /** 完了モード: 'application'=応募完了, 'exchange'=交換完了 */
  mode?: 'application' | 'exchange'
  /** 交換した商品名（mode='exchange' のときのみ表示） */
  prizeName?: string | null
  /** 使用したスポット名（スポット記録型クーポンのときのみ表示） */
  spotName?: string | null
  /** クーポン型の場合 true（見出しの動詞を「使用しました」に切り替える） */
  isCoupon?: boolean
}

const CONTENT = {
  application: {
    title: '応募完了',
    heading: '応募が完了しました',
    description: '',
  },
  exchange: {
    title: '受け取りを完了しました',
    heading: '特典の交換が完了しました',
    // 不要なので空にしている
    description: '',
  },
} as const

/**
 * 応募/交換完了確認ダイアログ。
 * mode prop で文言を切り替える。
 * Figma: node 561-22411
 */
export function DialogV2ApplyComplete({ opened, onClose, mode = 'exchange', prizeName, spotName, isCoupon }: Props) {
  const { t } = useTranslation()
  const content = CONTENT[mode]
  const verb = isCoupon ? '使用しました' : '受け取りました'
  const exchangeHeading = mode === 'exchange' && prizeName ? `「${prizeName}」を${verb}` : content.heading
  const title = mode === 'exchange' && isCoupon ? 'クーポンを使用しました' : content.title
  return (
    <Dialog selectorState={opened} closeFunc={onClose} title={title} compact>
      <div className="flex flex-col items-center gap-4 px-4 py-6">
        <p className="text-center text-[15px] font-bold leading-[24px] text-black">{exchangeHeading}</p>
        {mode === 'exchange' && spotName && (
          <div>
            <p className="text-center text-[15px] font-bold mt-4 text-black">{t('coupon.use_spot', '使用スポット')}</p>
            <p className="text-center text-[15px] font-bold mt-2 mb-4 text-black">{spotName}</p>
          </div>
        )}
        {content.description && (
          <p className="text-center text-[13px] leading-[20px] text-gray-600">{content.description}</p>
        )}
        <Button label="閉じる" variant="primary" size="md" fullWidth onClick={onClose} />
      </div>
    </Dialog>
  )
}
